import React, { SVGProps } from 'react';

const DefaultDateIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6.25375 2.5V5.00104" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M13.7567 2.5V5.00104" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M2.50195 7.92075H17.5082" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <rect
        height="13.7557"
        width="15.0062"
        rx="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        x="2.50195"
        y="3.75391"
      />
    </svg>
  );
};

export default DefaultDateIcon;
